<div class="file-list-label">{{ fileListLabel }}</div>
<i2g-job-file-list-item
  *ngFor="let item of listItems"
  [showDeleteButton]="item.showDeleteButton"
  [fileName]="item.fileName"
  [fileType]="item.fileType"
>
</i2g-job-file-list-item>
